const getItemStyle = (isDragging, draggableStyle) => ({
  opacity: isDragging ? '.5' : '1',

  // styles we need to apply on draggables
  ...draggableStyle,
});

export default getItemStyle;